import { BASE_URL } from "../api_const"

export const URL_ADD_TO_WISHLIST = BASE_URL + "/wishlist/create"
export const URL_GET_WISHLISTS = BASE_URL + ""

export const URL_GET_ALL_WISHLIST = BASE_URL + "/wishlist/wishlistall"